import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { ChangePasswordForm } from '@/components/auth';

const ChangePasswordPage: React.FC = () => {
  const { isAuthenticated, loading } = useAuth();

  // Show loading state while checking auth
  if (loading) {
    return null;
  }

  // This page requires authentication, redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  return <ChangePasswordForm />;
};

export default ChangePasswordPage;
